import client from './';
import { config } from 'config';

export const getFlights = async (params) => {
  let api = `${window.location.origin}/travel/travel-api/web/flights/status?`;

  Object.keys(params).forEach((key) => {
    api += `${key}=${params[key]}&`;
  });

  return await client(api, 'get');
};

export const getFlightLocation = async (date, flightNumber) => {
  const api = `https://labsapi.flysas.com/labs-api/v1/multilink/route/${date}-${flightNumber}`;

  return await client(api, 'get');
};

export const getPlanesPosition = async () => {
  const api = 'https://labsapi.flysas.com/labs-api/v1/multilink/inAir';

  return await client(api, 'get');
};
